import Vue from 'vue'
import App from '@/App.vue'
import webrouter from '@/router/webrouter'
import webrouterdev from '@/router/webrouter.dev'
import adminrouter from '@/router/adminrouter'
import store from '@/store'
import axios from '@/backend'
import logtest from '@/logger/logtest'
//import log from '@/logger'
import settings from '@/model/settings'
import vuetify from '@/plugins/vuetify'
//import '@/registerServiceWorker'
import '@/filters/dateFilter'
import '@/filters/stringFilter'
import '@/filters/numFilter'
import '@/filters/paperFilter'
import '@/sass/main.scss'
//import '@/stylus/main.styl'
import VueCookies from 'vue-cookies'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'  //Globally import VTextField
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// For Vue 2




Vue.component('v-text-field', VTextField)

Vue.use(VCurrencyField, { 
	locale: 'sv-SE',
	decimalLength: 0,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0,
    valueAsInteger: false,
    allowNegative: true
})
//TODO: Remove
Vue.config.devtools = (settings.env === 'staging' ||settings.env === 'development')
Vue.use(VueCookies)
// https://www.npmtrends.com/bowser-vs-mobile-detect-vs-ua-parser-js-vs-useragent
// https://www.npmtrends.com/js-logger-vs-log4js-vs-loglevel-vs-jsnlog
logtest.test()

Vue.use(Toast)
Vue.config.productionTip = false

const host = window.location.host
const parts = host.split('.')
//const domainLength = 3 // route1.example.com => domain length = 3

const router = () => {
  let routes
   if (parts[0] === 'admin' || parts[0] === 'admin-dev') {
    routes = adminrouter  
  } else { 
    if(settings.env === 'production'){
      routes = webrouter
    }
    else if(settings.env === 'staging'){
      routes = webrouter
    } 
    else{
      routes = webrouterdev
    }
  }
  return routes
}

console.log('Initializing...')
console.log('Settings:', settings)

// window.onerror = function (msg, url, line, col, error) {
//   //code to handle or report error goes here
// }

// Vue.config.errorHandler = function (err, vm, info) {
//   // handle error
//   // `info` is a Vue-specific error info, e.g. which lifecycle hook
//   // the error was found in. Only available in 2.2.0+
// }
// Vue.mixin({
//   created() {
//     log.debug('[created] ' + this.$options.name)
//   },   
//   mounted() {
//     log.debug('[mounted] ' + this.$options.name)
//   }, 
// })



new Vue({
  vuetify,
  axios,
  router:router(),
  store,
  render: h => h(App)
}).$mount('#app')
